import { promotions } from "@/mocks/homeData";

const badgeColors: Record<string, string> = {
  "热门": "bg-accent-500 text-background-50",
  "推荐": "bg-primary-500 text-background-50",
  "尊享": "bg-secondary-600 text-background-50",
  "限时": "bg-accent-400 text-background-50",
};

export default function Promotions() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            限时优惠活动
          </h2>
          <p className="mt-3 text-foreground-600 text-base">
            多重好礼等您来拿，新老玩家皆有福利
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className="relative bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-primary-500/20 transition-all duration-300 group"
            >
              {promo.badge && (
                <span
                  className={`absolute top-3 right-3 px-2.5 py-0.5 text-xs font-semibold rounded-full ${badgeColors[promo.badge] || "bg-primary-500 text-background-50"}`}
                >
                  {promo.badge}
                </span>
              )}
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500/10 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${promo.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">
                {promo.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {promo.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}